import { render, staticRenderFns } from "./UIComponents.vue?vue&type=template&id=144061a4"
import script from "./UIComponents.vue?vue&type=script&lang=ts"
export * from "./UIComponents.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports